export default "__VITE_ASSET__DGONOmBh__"